import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const fetchTicketUrlAction = {
    ...operations,
    ...selectors,
};

export {
    fetchTicketUrlAction,
};
export default {
    [namespace]: reducer,
};
